import { capitalize, sortBy } from 'lodash';
import { useMultiProjectDashboardContext } from '../../contexts/MultiProjectDashboardContext';
import ExportProjectsCsvButton from './ExportProjectsCsvButton';
import { useAreaUnits } from '../../contexts/UnitContext';
import { asQuantity } from '../../utils/formatters';

const getColumns = (areaFormatter, longUnitName) => [
  { displayString: 'Farm', accessor: 'farmName' },
  { displayString: 'Crop', accessor: (row) => row.crop?.name },
  {
    displayString: 'Stem Count',
    accessor: (row) => row.ecologicalSummary?.treeCount,
    format: asQuantity,
  },
  {
    displayString: `Total ${capitalize(longUnitName)}`,
    accessor: (row) => row.ecologicalSummary?.acreage,
    format: areaFormatter,
  },
];

const ExportDashboardCropsButton = () => {
  const {
    dashboards: { dashboardFarms },
  } = useMultiProjectDashboardContext();
  const { areaFormatter, longUnitName } = useAreaUnits();

  const fetchData = () =>
    sortBy(dashboardFarms, 'name').flatMap((farm) =>
      sortBy(farm.cropAggregates, 'crop.name').map((cropAggregate) => ({
        ...cropAggregate,
        farmName: farm.name,
      })),
    );
  return (
    <ExportProjectsCsvButton
      columns={getColumns(areaFormatter, longUnitName)}
      exportType="crops"
      fetchData={fetchData}
      // TODO: For persisted dashboard, add dashboard name to filename?
      filename="crops.csv"
    />
  );
};

export default ExportDashboardCropsButton;
